export class NotaFiscalRelatorioItem {
  IdCardeal : number;
  ReceberId : number;
  UUID : string;
  NumeroNFS : number;
  UsuarioEmissao : string;
  DataCriacao : string;
  ParticipanteTomador : string;
  ValorNota : number;
  LinkPDF : string;
  StatusNota : string;
  Discriminacao : string;
}

export class FiltrosNotaFiscal {
  public DataInicial?: string;
  public DataFinal?: string;
  public ParticipanteId: number;
  public ValorNota: number;
  public QuantidadeRegistros: number;
  public Texto: string;
  public UsuarioEmissaoId: number;
  
  constructor() {
    let hoje = new Date();
    
    hoje.setDate(1); // primeiro dia desse mês
    this.DataInicial = hoje.toISOString().split('T')[0];
    
    hoje.setMonth(hoje.getMonth() + 1); 
    hoje.setDate(0); // último dia desse mês (com esses dois comandos funcionou, vai saber kkkk)
    this.DataFinal = hoje.toISOString().split('T')[0];

    this.ParticipanteId = 0;
    this.ValorNota = 0;
    this.QuantidadeRegistros = 25;
    this.Texto = "";
    this.UsuarioEmissaoId = 0;
  }
}
